// extracted by mini-css-extract-plugin
export var alertIcon = "_uv-0";